import RichTextWithVideoBlock from './RichTextWithVideoBlock';

export default RichTextWithVideoBlock;
